// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2f7AX","emails":"CreateEditClinics_emails__2cBuJ","emailTagLabel":"CreateEditClinics_emailTagLabel__3xvA1"};